import { create } from "zustand";
import { TOOL_PLANS } from "../../constants/tool-payments";
import { ToolPaymentsStore } from "./types";

const useToolPaymentsStore = create<ToolPaymentsStore>((set) => ({
  selectedPlan: TOOL_PLANS.PRO,
  setSelectedPlan: (plan) => set({ selectedPlan: plan }),
  setComponentToShow: (comp) => set({ componentToShow: comp }),
  setTrialInfo: (trialInfo) => set(trialInfo),
  setIsSupportDoc: (setVal) => set({ isSupportDoc: setVal }),
}));

export default useToolPaymentsStore;
